import "./Navbar.css";
const Navbar = () => {
  return (
    <nav>
      <ul>
        <li>
          <a href="#">ABOUT US</a>
        </li>
        <li>
          <a href="#">FOR YOU</a>
        </li>
        <li>
          <a href="#">SERVICES</a>
        </li>
        <li>
          <a href="#">BLOG</a>
        </li>
        <li>
          <a href="#">VLOG</a>
        </li>
        <li>
          <a href="#">CONTACT</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;

